import React from "react";
import { useSelector } from "react-redux";
import { useAppDispatch } from "@redux/store";
import { setCartItems } from "@redux/cart/slice";
import { cartSelector } from "@redux/cart/selectors";
import { setCartItemsToStorage } from "@/utils";
import { addCurrencyWord } from "@/utils";

import styles from "./StorageCartItem.module.scss";

const MONTH_NAMES = [
  "Январь", "Февраль", "Март", "Апрель", "Май", "Июнь",
  "Июль", "Август", "Сентябрь", "Октябрь", "Ноябрь", "Декабрь",
];

interface StorageCartItemProps {
  storageKey: string;
  item: any;
  onDelete: (id: number) => void;
}

export const StorageCartItem: React.FC<StorageCartItemProps> = ({ storageKey, item }) => {
  const { totalCartItems } = useSelector(cartSelector);
  const dispatch = useAppDispatch();

  const handleDelete = () => {
    const cloneCartItems = JSON.parse(JSON.stringify(totalCartItems));
    const storage = cloneCartItems.storage || {};
    delete storage[storageKey];
    cloneCartItems.storage = storage;

    setCartItemsToStorage(cloneCartItems);
    dispatch(setCartItems(cloneCartItems));
  };

  const totalPrice = (item.price || 0) * (item.count || 1);

  return (
    <div className={styles.wrapper}>
      <div className={styles.itemContainer}>
        <div className={styles.infoContainer}>
          <p className={styles.title}>Хранение спортивного инвентаря</p>
          <p className={styles.month}>{MONTH_NAMES[item.month]}</p>
        </div>
        <div className={styles.priceContainer}>
          <button
            className={styles.deleteButton}
            onClick={handleDelete}
            aria-label="Удалить"
          />
          <p className={styles.price}>{addCurrencyWord(totalPrice)}</p>
        </div>
      </div>
    </div>
  );
};
